export const specialities: readonly string[] = [
  "Dentist",
  "Gynecologist",
  "General Physician",
  "Dermatologist",
  "Ear-nose-throat (ent) Specialist",
  "Homeopath",
  "Ayurveda",
  "Physiotherapist",
  "Orthopaedic Surgeon",
  "Cardiologist",
  "Neurologist",
  "Ophthalmologist",
  "Pediatrician",
  "Psychiatrist",
  "Urologist",
  "General Surgeon",
  "Anesthesiologist",
] as const;

export default specialities;
